'use client';

export { TabsList } from './TabsList';
export * from './TabsList.types';
export * from './tabsListClasses';